import React from 'react';

const Notification = ({ message, type, onClose }) => {
    const notificationClass = type === 'success' ? 'bg-green-500' : type === 'error' ? 'bg-red-500' : 'bg-blue-500';

    return (
        <div
            className={`fixed top-4 left-1/2 transform -translate-x-1/2 p-4 rounded text-white shadow-lg ${notificationClass}`}
            style={{ zIndex: 9999 }}
        >
            <div className="flex justify-between items-center">
                <span>{message}</span>
                <button onClick={onClose} className="text-xl font-bold">&times;</button>
            </div>
        </div>
    );
};

export default Notification;